import Swiper, { Pagination } from 'swiper'

const sliderClass = '.tags-slider'

function initTagsSlider() {

  if(!$(sliderClass).length) return false

  let swiper = new Swiper(sliderClass, {
    modules: [Pagination],
    slidesPerView: "auto",
    freeMode: true,
    spaceBetween: 8,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
  })

}

initTagsSlider()
